/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */
export interface PageTitleItem { path: string; label: string }

export function normalizePageTitlePath(path: string): string {
  return path.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
}

/** Segment boundaries matter: /orders must not name /orders-archive. */
export function findPageTitleItem(pathname: string, items: readonly PageTitleItem[], exact = false): string {
  const current = normalizePageTitlePath(pathname);
  return items
    .filter(({ path, label }) => {
      const route = normalizePageTitlePath(path);
      return label.trim() && (route === current || (!exact && route !== '/' && current.startsWith(`${route}/`)));
    })
    .sort((a, b) => normalizePageTitlePath(b.path).length - normalizePageTitlePath(a.path).length)[0]?.label ?? '';
}
